import {
  Global,
  ThemeProvider as EmotionProvider,
  useTheme,
} from "@emotion/react";
import { themePrototype } from "../styles/themePrototype";

function GlobalStyles() {
  const theme = useTheme();

  return <Global styles={theme.global} />;
}

function ThemeProvider({ children }: { children: React.ReactNode }) {
  return (
    <EmotionProvider theme={themePrototype}>
      <GlobalStyles />
      {children}
    </EmotionProvider>
  );
}

export { ThemeProvider };
